import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import restService from "../rest-service/RestService";
import { DateColumnTypeEnum, FileContainsTypeEnum, IColumn, IConfigImportFileParams, IConfiguration, IFileSaveResult, ILogEntry, IObjectMapInfo, IRunImportFileParams, ITagTypeMapInfo, ITagTypesParams, ImportTypeEnum } from "./Models";

interface QueryParams {
    objectType?: eLynxObjectTypeEnum;
    filestoreID?: number;
    configID?: number;
    
}
const DataFileImportDataService = {

    getConfiguration: async function (
        groupID: number,
        configID: number,
        signal?: AbortSignal
    ): Promise<IConfiguration> {

        if (configID > 0) {
            const path = `/groups/${groupID}/data-file-import-config/${configID}`;
            const response = await restService.get<IConfiguration>(path, signal);
            return response.data;
        } else {
            return {
                id: -1,
                columns: [],
                dateColumn: {
                    id: -1,
                    name: ''
                },
                dateColumnType: DateColumnTypeEnum.One,
                fileContainsType: FileContainsTypeEnum.DataForSingleDevice,
                fileHasHeaderRow: true,
                identifierColumn: {
                    id: -1,
                    name: ''
                },
                importObjectType: eLynxObjectTypeEnum.Device,
                importType: ImportTypeEnum.Single,
                name: "New Import Configuration",
                objectMap: [],
                tagTypeColumns: [],
                tagTypeMap: [],
                timeColumn: {
                    id: -1,
                    name: ''
                },
                timezone: {
                    id: 20,
                    name: '',
                    standardName: '',
                    olsonTimezone: ''
                },
                attributeName: ''
            };

        }
    },

    getDataFileImportConfigs: async function (
        groupID: number,
        signal?: AbortSignal
    ): Promise<IConfiguration[]> {

        const path = `/groups/${groupID}/data-file-import/configs`;
        const response = await restService.get<IConfiguration[]>(path, signal);
        return response.data.sort((a, b) => a.name.localeCompare(b.name));
    },
    getOrganizationObjects: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        signal?: AbortSignal
    ): Promise<IeLynxObject[]> {

        const path = `/groups/${groupID}/data-file-import/objects`;
        const queryParams: QueryParams = {
            objectType: objectType
        };
        const response = await restService.get<IeLynxObject[], QueryParams>(path, signal, queryParams);
        return response.data;
    },

    getProcessImportLog: async function (
        groupID: number,
        filestoreID: number,
        signal?: AbortSignal
    ): Promise<ILogEntry[]> {

        const path = `/groups/${groupID}/data-file-import/process-import-log`;
        const queryParams: QueryParams = {
            filestoreID: filestoreID
        };
        const response = await restService.get<ILogEntry[], QueryParams>(path, signal, queryParams);
        return response.data;
    },
    // public getProcessImportLog(contextGroupID: number, filestoreID: number): Services.RestPromise<DataFileImportModels.IProcessImportLog> {

    //     var path: string =
    //         [
    //             "groups",
    //             contextGroupID,
    //             "data-file-import",
    //             "process-import-log"
    //         ].join("/");

    //     var getQueryParams: Models.IDowloadFileStoreQueryParams = {
    //         filestoreID: filestoreID
    //     };

    //     return this._restService.get<Array<DataFileImportModels.ILogEntry>,
    //         Models.IDowloadFileStoreQueryParams>(path, getQueryParams)
    //         .then((data: Services.IRestResponse<Array<DataFileImportModels.ILogEntry>>) => {

    //             const processImportLog: DataFileImportModels.ProcessImportLog = new DataFileImportModels.ProcessImportLog();

    //             if (data.entity) {

    //                 processImportLog.processImportLogs = data.entity
    //                     ? data.entity.map((le: DataFileImportModels.ILogEntry): DataFileImportModels.LogEntry => {
    //                         return new DataFileImportModels.LogEntry(le);
    //                     })
    //                     : new Array<DataFileImportModels.LogEntry>();
    //             }

    //             return processImportLog;
    //         });
    // }

    saveConfiguration: async function (
        groupID: number,
        configuration: IConfiguration        
    ): Promise<IConfiguration> {

        const path = `/groups/${groupID}/data-file-import-config`;
        const response = await restService.post<IConfiguration, IConfiguration>(path, configuration);
        return response.data;
    },
    deleteConfiguration: async function (
        groupID: number,
        configuration: IConfiguration        
    ): Promise<void> {

        const path = `/groups/${groupID}/data-file-import-config`;
        await restService.delete<IConfiguration, IConfiguration>(path, undefined, undefined, configuration);
    },

    configGetCsvColumns: async function (
        groupID: number,
        importFileParams: IConfigImportFileParams,
        signal?: AbortSignal
    ): Promise<IColumn[]> {

        const path = `/groups/${groupID}/data-file-import-config/columns`;
        const response = await restService.post<IConfigImportFileParams, IColumn[]>(path, importFileParams, signal);
        return response.data;
    },

    configGetCsvObjectMap: async function (
        groupID: number,
        importFileParams: IConfigImportFileParams,
        signal?: AbortSignal
    ): Promise<IObjectMapInfo> {

        const path = `/groups/${groupID}/data-file-import-config/object-map`;
        const response = await restService.post<IConfigImportFileParams, IObjectMapInfo>(path, importFileParams, signal);
        const data = response.data;
        data.objectMap = data.objectMap.filter(o => o.identifier.length > 0);
        return data;
    },

    configGetTagTypesMap: async function (
        groupID: number,
        tagTypesParams: ITagTypesParams,
        signal?: AbortSignal
    ): Promise<ITagTypeMapInfo> {

        const path = `/groups/${groupID}/data-file-import-config/tag-types-map`;
        const response = await restService.post<ITagTypesParams, ITagTypeMapInfo>(path, tagTypesParams, signal);
        return response.data;
    },
    configSaveCsvFile: async function (
        groupID: number,
        importFileParams: IConfigImportFileParams,
        file: File
    ): Promise<IFileSaveResult> {

        const formData = new FormData();
        formData.append("file", file);

        const path = `/groups/${groupID}/data-file-import-config/import-file-csv/save`;
        const response = await restService.post<FormData, IFileSaveResult, IConfigImportFileParams >(
                path, 
                formData, 
                undefined, 
                'multipart/form-data', 
                importFileParams);
        return response.data;
    },
    // public configSaveCsvFile(groupID: number, importFileParams: DataFileImportModels.IConfigImportFileParams, uploadFormElement: HTMLFormElement): Services.RestPromise<DataFileImportModels.IFileSaveResult> {
    //     let formData = new FormData();
    //     formData.append("file", file);

    //     var path: string =[
    //         "groups",
    //         groupID,
    //         "data-file-import-config",
    //         "import-file-csv",
    //         "save"
    //     ].join("/");


    //     return this._restService.post<DataFileImportModels.IFileSaveResult, DataFileImportModels.IConfigImportFileParams>(path, formData, "multipart/form-data", importFileParams)
    //         .then((data: any) => {
    //             formData = null;
    //             return data.entity;
    //         });
    // }

    verifyAndRunCsvFile: async function (
        groupID: number,
        importFileParams: IRunImportFileParams
    ): Promise<void> {

        const path = `/groups/${groupID}/data-file-import/import-file-csv/verify-run`;
        await restService.post<IRunImportFileParams, void>(
                path, 
                importFileParams);
    },

    // public verifyAndRunCsvFile(groupID: number, runImportFileParams: DataFileImportModels.IRunImportFileParams): Services.RestPromise<DataFileImportModels.IObjectMapInfo> {

    //     var path: string = [
    //         "groups",
    //         groupID,
    //         "data-file-import",
    //         "import-file-csv",
    //         "verify-run"
    //     ].join("/");

    //     return this._restService.post<DataFileImportModels.IObjectMapInfo, DataFileImportModels.IRunImportFileParams>(path, runImportFileParams).
    //         then((data: Services.IRestResponse<DataFileImportModels.IObjectMapInfo>) => {

    //             return data.entity;
    //         });
    // }


    
    verifyAndSaveCsvFile: async function (
        groupID: number,
        configID: number,
        file: File
    ): Promise<IFileSaveResult> {

        const formData = new FormData();
        formData.append("file", file);

        const queryParams: QueryParams = {
            configID: configID
        }

        const path = `/groups/${groupID}/data-file-import/import-file-csv/verify-save`;
        const response = await restService.post<FormData, IFileSaveResult, QueryParams>(
                path, 
                formData,
                undefined,
                'multipart/form-data',
                queryParams);
        return response.data;
    },
    // public verifyAndSaveCsvFile(groupID: number, configID: number, uploadFormElement: HTMLFormElement): Services.RestPromise<DataFileImportModels.IFileSaveResult> {

    //     var path: string = [
    //         "groups",
    //         groupID,
    //         "data-file-import",
    //         "import-file-csv",
    //         "verify-save"
    //     ].join("/");

    //     var formData: FormData = new FormData(uploadFormElement);
    //     //formData.append("description", "test");

    //     return this._restService.post<DataFileImportModels.IFileSaveResult, any>(path, formData, "multipart/form-data", { configID: configID })
    //         .then((data: any) => {
    //             formData = null;
    //             return data.entity;
    //         });
    // }







};

export default DataFileImportDataService;

